import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ContactForm from './ContactForm';
import FormInput from './FormInput';
import Center from './Center';
import FurnishedLiving from './FurnishedLiving';
import HalfScreenTextParent from './HalfScreenTextParent';
import CenteredTextTest from './CenteredTextTest';
import Fade from 'react-reveal/Fade';
import TiArrowRight from 'react-icons/lib/ti/arrow-right';
import FlexCenter from './FlexCenter';
import rightarrow from './rightarrow.png';
import axios from 'axios';
import Modal from 'react-modal';

class Contact extends Component {
  constructor(){
    super()
    this.state = {
      scrollHeight: document.documentElement.scrollTop,
      newReactKey: 1
    }
  }
  componentWillMount(){
    this.props.changeClass()
  }
  componentDidMount(){
    window.addEventListener('scroll', () => this.setState({scrollHeight: document.documentElement.scrollTop}))
    var floorPlanHeight = () => {
      if(document.getElementById('contact-section')){
        var fph = document.getElementById('contact-section').offsetHeight;
        this.setState({newReactKey: (fph/window.innerHeight)})
      } else {
        this.setState({newReactKey: 1})
      }
    }
    floorPlanHeight();
  }
  componentWillUnmount(){
    window.removeEventListener('scroll', () => this.setState({scrollHeight: document.documentElement.scrollTop}))
  }
  render(){
    var s = this.state;
    var contentObj = furnishedLivingObj;
    if(this.props.content === "gallery"){
      contentObj = galleryObj
    }
    return (
      <div>
        <div id="contact-section">
          <div className="contact-page-frame">
            <div className="col-lg-2 col-md-1 col-sm-1 col-xs-1"></div>
            <div style={{height: '100%'}} className="col-lg-8 col-md-10 col-sm-10 col-xs-10">
              <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                <FlexCenter width={'100%'}>
                  <div>
                    <Fade top>
                      <h1 className="ourStandardH1 formHeader" style={{textTransform: 'uppercase',fontFamily: 'proxima-nova', font: '200 25px/30px "proxima-nova", "open-sans", Arial, Helvetica, sans-serif'}}>{contentObj.title}</h1>
                    </Fade>
                    <Fade bottom>
                      <div className="textBeforeForm">{contentObj.text1}</div>
                    </Fade>
                  </div>
                </FlexCenter>
              </div>
              <div><FormInput/></div>
            </div>
            <div className="col-lg-2 col-md-1 col-sm-1 col-xs-1"></div>
          </div>
        </div>
      </div>
    )
  }
}

export default Contact;

var furnishedLivingObj = {
  title: 'Get In Touch',
  text1: 'You can always reach us by email at info@furnishedlivingla.com or leave a message in the box below. The more information you provide the quicker we can assist you. We will respond in 24-48 hours. Our phone humber is this what else do you want say here.' ,
  text2: 'Our furnished units are located in walking distance to anything you may need. In West Hollywood, we are just off Robertson, and in Santa Monica we are steps from the beach on Montana Ave. This is further dummy information that CLIENT may want to put here.',
  buttonText: 'Send'
}

var galleryObj = {
  title: 'Luxury & Comfort',
  text1: 'Our luxury furnished apartments are situated in the finest areas of West Hollywood and Santa Monica. We offer long-term rentals (30 days minimum) in our studio, one-bedroom, and two-bedroom apartments. Each unit is finished with fine appliances and detailed decorations. We balance style and comfort to provide a home away from home.' ,
  text2: 'Our furnished units are located in walking distance to anything you may need. In West Hollywood, we are just off Robertson, and in Santa Monica we are steps from the beach on Montana Ave. This is further dummy information that CLIENT may want to put here.',
  buttonText: 'Explore Gallery'
}



// WEBPACK FOOTER //
// ./src/Contact.js